import { supabase } from './supabase.js'

const entries = new Map()
const TTL = 15 * 60 * 1000

export async function earningsRequest(symbol) {
  const { data: { session } } = await supabase.auth.getSession()
  if (!session?.access_token) throw new Error('Earnings dates unavailable')
  const key = `${session.user?.id || ''}:${symbol}`
  const entry = entries.get(key)
  if (entry?.expiresAt > Date.now()) return entry.promise
  if (entries.size >= 200) entries.delete(entries.keys().next().value)
  const promise = (async () => {
    const response = await fetch(`/api/market-data/earnings?symbol=${encodeURIComponent(symbol)}`, {
      headers: { Authorization: `Bearer ${session.access_token}` }, signal: AbortSignal.timeout(15_000),
    })
    if (!response.ok) throw new Error('Earnings dates unavailable')
    const value = await response.json()
    if (value.symbol !== symbol || !Array.isArray(value.events) || !Number.isFinite(Date.parse(value.retrievedAt))) {
      throw new Error('Earnings dates unavailable')
    }
    return value
  })()
  entries.set(key, { promise, expiresAt: Date.now() + TTL })
  try {
    const result = await promise
    const current = entries.get(key)
    if (current?.promise === promise) current.expiresAt = Date.parse(result.retrievedAt) + TTL
    return result
  } catch (error) {
    // Short negative cache prevents multiple panes from hammering an unavailable service.
    const current = entries.get(key)
    if (current?.promise === promise) current.expiresAt = Date.now() + 60_000
    throw error
  }
}
